import { useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import TextField from 'components/TextField';
import Form from 'components/Form';

import { useErrorHandler } from 'lib';
import { TravelDocumentEditForm_document$key } from '__generated__/TravelDocumentEditForm_document.graphql';

type FormFields = {
  name: string;
};

type Props = {
  document: TravelDocumentEditForm_document$key;
};

const TravelDocumentEditForm = (props: Props) => {
  const errorHandler = useErrorHandler();

  const { id, name } = useFragment(
    graphql`
      fragment TravelDocumentEditForm_document on TravelDocument {
        id
        name
      }
    `,
    props.document
  );

  const [update, updating] = useMutation(graphql`
    mutation TravelDocumentEditFormMutation(
      $id: ID!
      $input: UpdateTravelDocumentInput!
    ) {
      updateTravelDocument(id: $id, input: $input) {
        ...EntitySidebar_entity
        ...TravelDocumentEditForm_document
      }
    }
  `);

  const handleSubmit = useCallback(
    (input: FormFields) => {
      update({
        variables: { id, input },

        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormFields> initialValues={{ name }} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="termEditForm">
          <Section id="about" title="Apie">
            <Stack spacing={4}>
              <TextField autoFocus name="name" label="Pavadinimas" fullWidth />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default TravelDocumentEditForm;
